export default [
  {
    path: '/catRecycling/commodityManagement/integralBorrowing',
    name: 'integralBorrowing',
    meta: {
      keepAlive: true,
      title: '积分借用'
    },
    component: () =>
      import(/* webpackChunkName: "activityList" */ '@/views/catRecycling/commodity-management/integral-borrowing')
  },
  {
    path: '/intgeralViews',
    name: 'intgeralViews',
    meta: {
      title: '查看积分借用'
    },
    component: () =>
      import(/* webpackChunkName: "activityList" */ '@/views/catRecycling/commodity-management/views/intgeral-views')
  },
  {
    path: '/catRecycling/commodityManagement/sharedLease',
    name: 'sharedLease',
    meta: {
      keepAlive: true,
      title: '共享租赁'
    },
    component: () =>
      import(/* webpackChunkName: "activityList" */ '@/views/catRecycling/commodity-management/shared-lease')
  },
  {
    path: '/sharedViews',
    name: 'sharedViews',
    meta: {
      title: '查看共享租赁'
    },
    component: () =>
      import(/* webpackChunkName: "activityList" */ '@/views/catRecycling/commodity-management/views/shared-views')
  },
  {
    path: '/catRecycling/commodityManagement/idleSecondHand',
    name: 'idleSecondHand',
    meta: {
      keepAlive: true,
      title: '闲置二手'
    },
    component: () =>
      import(/* webpackChunkName: "activityList" */ '@/views/catRecycling/commodity-management/idle-second-hand')
  },
  {
    path: '/catRecycling/commodityManagement/idleSecondViews',
    name: 'idleSecondViews',
    meta: {
      title: '查看闲置二手'
    },
    component: () =>
      import(/* webpackChunkName: "activityList" */ '@/views/catRecycling/commodity-management/views/idle-second-views')
  },
  /** 订单管理 */
  {
    path: '/catRecycling/OrderManagement/integralBorrowing',
    name: 'integralBorrowing',
    meta: {
      title: '积分借用'
    },
    component: () =>
      import(/* webpackChunkName: "activityDetails" */ '@/views/catRecycling/order-management/integral-borrowing')
  },
  {
    path: '/integralView',
    name: 'integralView',
    meta: {
      title: '查看积分借用'
    },
    component: () =>
      import(/* webpackChunkName: "activityDetails" */ '@/views/catRecycling/order-management/views/integral-view')
  },
  {
    path: '/catRecycling/OrderManagement/sharedLease',
    name: 'sharedLease',
    meta: {
      keepAlive: true,
      title: '共享租赁'
    },
    component: () =>
      import(/* webpackChunkName: "activityList" */ '@/views/catRecycling/order-management/shared-lease')
  },
  {
    path: '/sharedView',
    name: 'sharedView',
    meta: {
      title: '查看共享租赁'
    },
    component: () =>
      import(/* webpackChunkName: "activityDetails" */ '@/views/catRecycling/order-management/views/shared-view')
  },
  {
    path: '/catRecycling/OrderManagement/idleSecondHand',
    name: 'idleSecondHand',
    meta: {
      keepAlive: true,
      title: '闲置二手'
    },
    component: () =>
      import(/* webpackChunkName: "activityList" */ '@/views/catRecycling/order-management/idle-second-hand')
  },
  {
    path: '/idleSecondView',
    name: 'idleSecondView',
    meta: {
      title: '闲置二手查看'
    },
    component: () =>
      import(/* webpackChunkName: "activityList" */ '@/views/catRecycling/order-management/views/idle-second-view')
  },
  {
    path: '/catRecycling/DigitalRecycling/transacManage',
    name: 'transacManage',
    meta: {
      keepAlive: true,
      title: '交易管理'
    },
    component: () =>
      import(/* webpackChunkName: "activityList" */ '@/views/catRecycling/digital-recycling/transac-manage')
  },
  {
    path: '/transacView',
    name: 'transacView',
    meta: {
      title: '交易管理查看'
    },
    component: () =>
      import(/* webpackChunkName: "activityList" */ '@/views/catRecycling/digital-recycling/views/transac-view')
  }
]
